import { render, staticRenderFns } from "./test-portal-version-management.vue?vue&type=template&id=283f94c8&"
import script from "./test-portal-version-management.vue?vue&type=script&lang=js&"
export * from "./test-portal-version-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "test-portal-version-management.vue"
export default component.exports